import React, { useState } from "react";
import "../css/Header5.css";

const Header5 = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="header5">

        {/* ========== TOP UTILITY BAR ========== */}
        <div className="h5-utility">

          <div className="util-logo">EARTHFIT</div>

          <div className="util-right">
            <span>Open 6am – 10pm</span>
            <span>•</span>
            <span>+1 800 244 9023</span>

            <div className="util-socials">
              <a href="#"><i className="ri-instagram-line"></i></a>
              <a href="#"><i className="ri-facebook-fill"></i></a>
              <a href="#"><i className="ri-youtube-fill"></i></a>
            </div>
          </div>
        </div>


        {/* ========== MAIN NAV BAR ========== */}
        <div className="h5-lowerbar">

          <nav className="h5-nav">
            <a href="/">Home</a>
            <a href="/about">About</a>
            <a href="/workouts">Workouts</a>
            <a href="/services">Services</a>
            <a href="/plans">Plans</a>
            <a href="/gallery">Gallery</a>
            <a href="/trainers">Trainers</a>
            <a href="/faqs">FAQs</a>
          </nav>

          <a href="/contact" className="h5-cta">Contact</a>

          {/* Hamburger */}
          <div className={`h5-ham ${open ? "open" : ""}`} onClick={() => setOpen(!open)}>
            <span></span><span></span><span></span>
          </div>
        </div>

        <div className="h5-wave"></div>
      </header>


      {/* ========== MOBILE MENU ========== */}
      <div className={`h5-mobile ${open ? "show" : ""}`}>
        <div className="m-head">
          <h2>EARTHFIT</h2>
          <span className="m-close" onClick={() => setOpen(false)}>×</span>
        </div>

        <div className="m-links">
          <a href="/" onClick={() => setOpen(false)}>Home</a>
          <a href="/about" onClick={() => setOpen(false)}>About</a>
          <a href="/workouts" onClick={() => setOpen(false)}>Workouts</a>
          <a href="/services" onClick={() => setOpen(false)}>Services</a>
          <a href="/plans" onClick={() => setOpen(false)}>Plans</a>
          <a href="/gallery" onClick={() => setOpen(false)}>Gallery</a>
          <a href="/trainers" onClick={() => setOpen(false)}>Trainers</a>
          <a href="/faqs" onClick={() => setOpen(false)}>FAQs</a>
          <a href="/contact" onClick={() => setOpen(false)}>Contact</a>
        </div>
      </div>
    </>
  );
};

export default Header5;
